// extracted by extract-css-chunks-webpack-plugin
module.exports = {"buttonLink":"_4xAHOM4tSzOH","button":"OqzoWHINniXH"};